// libs
import { orderBy, map } from 'lodash';
// endpoints
import { getStoresV3, getWarningStore } from '@/services/stores';
import { getActiveSellers, getAvailableEmails } from '@/services/oto/sellers';

const sellers = {
  namespaced: true,
  state: {
    activePage: 'Sellers',
    storesList: [],
    warningStoresList: [],
    activeSellersList: [],
    emailList: [],
    loadingEmailList: false,
    loadingTab: true,
    selectedTab: {
      id: 'tab-all-sellers',
      name: 'Todos os vendedores',
    },
    orderBy: 'name',
    statusFilter: 'active',
    filterValues: {
      name: '',
      enrolment: '',
      storeName: '',
      store: '',
      whatsapp: '',
    },
  },
  mutations: {
    SET_ACTIVE_PAGE(state, payload) {
      state.activePage = payload;
    },
    SET_SELECTED_TAB(state, payload) {
      state.selectedTab = payload;
    },
    SET_LOADING_TAB(state, payload) {
      state.loadingTab = payload;
    },
    ADD_STORES(state, stores) {
      state.storesList = stores;
    },
    ADD_WARNING_STORES(state, stores) {
      state.warningStoresList = stores;
    },
    ADD_ACTIVE_SELLERS(state, activeSellers) {
      state.activeSellersList = activeSellers;
    },
    SET_EMAIL_LIST(state, emails) {
      state.emailList = emails;
    },
    UPDATE_EMAIL_LOADING(state, status) {
      state.loadingEmailList = status;
    },
    RESET_EMAIL_LIST(state) {
      state.emailList = [];
    },
    SET_FILTER_VALUES(state, filterValues) {
      state.filterValues = { ...state.filterValues, ...filterValues };
    },
    SET_STATUS_FILTER(state, statusFilter) {
      state.statusFilter = statusFilter;
    },
    RESET_FILTER_VALUES(state) {
      state.filterValues = {
        name: '',
        enrolment: '',
        storeName: '',
        store: '',
        whatsapp: '',
      };
    },
    RESET_STATUS_FILTER(state) {
      state.statusFilter = 'active';
    },
    SET_ORDER_BY(state, orderBy) {
      state.orderBy = orderBy;
    },
  },
  actions: {
    setActivePage({ commit }, payload) {
      commit('SET_ACTIVE_PAGE', payload);
    },
    setSelectedTab({ commit }, payload) {
      commit('SET_SELECTED_TAB', payload);
    },
    setLoadingTab({ commit }, payload) {
      commit('SET_LOADING_TAB', payload);
    },
    getStoresList({ commit }) {
      const SHOW_ALL_STORES = 0;
      const ONLY_ACTIVE_STORES = 1;

      getStoresV3(SHOW_ALL_STORES, ONLY_ACTIVE_STORES).then(({ data }) => {
        commit('ADD_STORES', data);
      });
    },
    getWarningStoresList({ commit }) {
      getWarningStore().then(({ data }) => {
        commit('ADD_WARNING_STORES', data);
      });
    },
    getActiveSellersList({ commit }) {
      getActiveSellers().then(response => {
        const data = response?.data?.data;
        commit('ADD_ACTIVE_SELLERS', data);
      });
    },
    getAvailableEmailList({ commit }, email) {
      commit('UPDATE_EMAIL_LOADING', true);
      getAvailableEmails(email)
        .then(({ data }) => {
          commit('SET_EMAIL_LIST', data.data);
        })
        .finally(() => commit('UPDATE_EMAIL_LOADING', false));
    },
    resetEmailList({ commit }) {
      commit('RESET_EMAIL_LIST');
    },
    setFilterValues({ commit }, filterValues) {
      commit('SET_FILTER_VALUES', filterValues);
    },
    setStatusFilter({ commit }, statusFilter) {
      commit('SET_STATUS_FILTER', statusFilter);
    },
    resetFilterValues({ commit }) {
      commit('RESET_FILTER_VALUES');
    },
    resetStatusFilter({ commit }) {
      commit('RESET_STATUS_FILTER');
    },
    setOrderBy({ commit }, orderBy) {
      commit('SET_ORDER_BY', orderBy);
    },
  },
  getters: {
    getActivePage: state => state.activePage,
    getOrderedStores: state =>
      orderBy(
        map(state.storesList, store => ({ id: store.id, name: store.store })),
        'name',
      ),
    getOrderedWarningStores: state =>
      orderBy(
        map(state.warningStoresList, store => ({ id: store.id, name: store.store })),
        'name',
      ),
    getSelectedTab: state => state.selectedTab,
    getOrderedActiveSellers: state =>
      orderBy(
        map(state.activeSellersList, store => ({
          id: store.id,
          name: store.name,
        })),
        'name',
      ),
    getAvailableEmails: state => state.emailList,
    getEmailLoadingStatus: state => state.loadingEmailList,
    getFilterValues: state => state.filterValues,
    getStatusFilter: state => state.statusFilter,
    getOrderBy: state => state.orderBy,
    getFormattedFilters: state => {
      const formatFilterValues = Object.entries(state.filterValues).flatMap(([key, value]) => {
        if (value && value.trim() !== '') {
          return [{ column: key, value: value }];
        }
        return [];
      });

      return formatFilterValues;
    },
    getEnabledValue: () => status => {
      if (Array.isArray(status) && status.length > 1) return null;

      switch (status) {
        case 'active':
          return 1;
        case 'inactive':
          return 0;
        default:
          return 1;
      }
    },
  },
};

export default sellers;
